<template>
  <b-modal
    id="long-answer-modal"
    size="xl"
    centered
    hide-footer
    header-class="d-flex justify-content-between align-items-center"
    body-class="p-0"
    style="max-width: 1000px !important;"
  >
    <template
      #modal-header
    >
      <b-media no-body>
        <b-media-aside>
          <b-avatar
            variant="light-primary"
            :text="content && getInitials(content.user.fullName)"
          />
        </b-media-aside>
        <b-media-body class="text-capitalize">
          <h6 class="transaction-title">
            {{ content && content.user.fullName }}
          </h6>
          <small>{{ content && content.user.role }}</small>
        </b-media-body>
      </b-media>
      <div>
        <span>
          {{ content && content.date.toDate().toLocaleString('fi', {day: '2-digit', month: '2-digit', year: '2-digit',hour: '2-digit', minute:'2-digit'}) }}
        </span>
        <feather-icon
          icon="MoreVerticalIcon"
          class="ml-1"
        />
      </div>
    </template>
    <b-card-text style="margin: 30px 20px;">
      {{ content && content.label }}
    </b-card-text>
  </b-modal>
</template>

<script>
import {
  BCardText, BModal, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'
import { getInitials } from '@hw-core/utils'

export default {
  components: {
    BCardText,
    BModal,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
  },
  props: {
    content: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getInitials,
  },
}
</script>

<style lang="scss" scoped>
::v-deep div {
  .modal-dialog.modal-dialog-centered {
    justify-content: center;
    .modal-content {
      max-width: 1000px;
    }
  }
}
</style>
